export default "__VITE_ASSET__CT2WMxg1__"